var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._v("表单设计器")])
}
var staticRenderFns = []

export { render, staticRenderFns }